import { defaultThemeData as b, calculateHSLColor as P, getMatchingPrimitiveToken as R, getTokenLastSubstring as z } from "./theme-generator.utils.js";
function x(a) {
  "@babel/helpers - typeof";

  return x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
    return typeof e;
  } : function (e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, x(a);
}
var W = /^\s+/,
  X = /\s+$/;
function i(a, e) {
  if (a = a || "", e = e || {}, a instanceof i) return a;
  if (!(this instanceof i)) return new i(a, e);
  var t = $(a);
  this._originalInput = a, this._r = t.r, this._g = t.g, this._b = t.b, this._a = t.a, this._roundA = Math.round(100 * this._a) / 100, this._format = e.format || t.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = t.ok;
}
i.prototype = {
  isDark: function () {
    return this.getBrightness() < 128;
  },
  isLight: function () {
    return !this.isDark();
  },
  isValid: function () {
    return this._ok;
  },
  getOriginalInput: function () {
    return this._originalInput;
  },
  getFormat: function () {
    return this._format;
  },
  getAlpha: function () {
    return this._a;
  },
  getBrightness: function () {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function () {
    var e = this.toRgb(),
      t,
      n,
      f,
      r,
      o,
      l;
    return t = e.r / 255, n = e.g / 255, f = e.b / 255, t <= 0.03928 ? r = t / 12.92 : r = Math.pow((t + 0.055) / 1.055, 2.4), n <= 0.03928 ? o = n / 12.92 : o = Math.pow((n + 0.055) / 1.055, 2.4), f <= 0.03928 ? l = f / 12.92 : l = Math.pow((f + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * o + 0.0722 * l;
  },
  setAlpha: function (e) {
    return this._a = w(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function () {
    var e = T(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function () {
    var e = T(this._r, this._g, this._b),
      t = Math.round(e.h * 360),
      n = Math.round(e.s * 100),
      f = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + t + ", " + n + "%, " + f + "%)" : "hsva(" + t + ", " + n + "%, " + f + "%, " + this._roundA + ")";
  },
  toHsl: function () {
    var e = _(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function () {
    var e = _(this._r, this._g, this._b),
      t = Math.round(e.h * 360),
      n = Math.round(e.s * 100),
      f = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + t + ", " + n + "%, " + f + "%)" : "hsla(" + t + ", " + n + "%, " + f + "%, " + this._roundA + ")";
  },
  toHex: function (e) {
    return M(this._r, this._g, this._b, e);
  },
  toHexString: function (e) {
    return "#" + this.toHex(e);
  },
  toHex8: function (e) {
    return j(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function (e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function () {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function () {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function () {
    return {
      r: Math.round(h(this._r, 255) * 100) + "%",
      g: Math.round(h(this._g, 255) * 100) + "%",
      b: Math.round(h(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function () {
    return this._a == 1 ? "rgb(" + Math.round(h(this._r, 255) * 100) + "%, " + Math.round(h(this._g, 255) * 100) + "%, " + Math.round(h(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(h(this._r, 255) * 100) + "%, " + Math.round(h(this._g, 255) * 100) + "%, " + Math.round(h(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function () {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : te[M(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function (e) {
    var t = "#" + H(this._r, this._g, this._b, this._a),
      n = t,
      f = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var r = i(e);
      n = "#" + H(r._r, r._g, r._b, r._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + f + "startColorstr=" + t + ",endColorstr=" + n + ")";
  },
  toString: function (e) {
    var t = !!e;
    e = e || this._format;
    var n = !1,
      f = this._a < 1 && this._a >= 0,
      r = !t && f && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return r ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), n || this.toHexString());
  },
  clone: function () {
    return i(this.toString());
  },
  _applyModification: function (e, t) {
    var n = e.apply(null, [this].concat([].slice.call(t)));
    return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
  },
  lighten: function () {
    return this._applyModification(q, arguments);
  },
  brighten: function () {
    return this._applyModification(U, arguments);
  },
  darken: function () {
    return this._applyModification(Z, arguments);
  },
  desaturate: function () {
    return this._applyModification(V, arguments);
  },
  saturate: function () {
    return this._applyModification(B, arguments);
  },
  greyscale: function () {
    return this._applyModification(D, arguments);
  },
  spin: function () {
    return this._applyModification(J, arguments);
  },
  _applyCombination: function (e, t) {
    return e.apply(null, [this].concat([].slice.call(t)));
  },
  analogous: function () {
    return this._applyCombination(Y, arguments);
  },
  complement: function () {
    return this._applyCombination(K, arguments);
  },
  monochromatic: function () {
    return this._applyCombination(ee, arguments);
  },
  splitcomplement: function () {
    return this._applyCombination(Q, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function () {
    return this._applyCombination(A, [3]);
  },
  tetrad: function () {
    return this._applyCombination(A, [4]);
  }
};
i.fromRatio = function (a, e) {
  if (x(a) == "object") {
    var t = {};
    for (var n in a) a.hasOwnProperty(n) && (n === "a" ? t[n] = a[n] : t[n] = I(a[n]));
    a = t;
  }
  return i(a, e);
};
function $(a) {
  var e = {
      r: 0,
      g: 0,
      b: 0
    },
    t = 1,
    n = null,
    f = null,
    r = null,
    o = !1,
    l = !1;
  return typeof a == "string" && (a = re(a)), x(a) == "object" && (g(a.r) && g(a.g) && g(a.b) ? (e = N(a.r, a.g, a.b), o = !0, l = String(a.r).substr(-1) === "%" ? "prgb" : "rgb") : g(a.h) && g(a.s) && g(a.v) ? (n = I(a.s), f = I(a.v), e = G(a.h, n, f), o = !0, l = "hsv") : g(a.h) && g(a.s) && g(a.l) && (n = I(a.s), r = I(a.l), e = O(a.h, n, r), o = !0, l = "hsl"), a.hasOwnProperty("a") && (t = a.a)), t = w(t), {
    ok: o,
    format: a.format || l,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: t
  };
}
function N(a, e, t) {
  return {
    r: h(a, 255) * 255,
    g: h(e, 255) * 255,
    b: h(t, 255) * 255
  };
}
function _(a, e, t) {
  a = h(a, 255), e = h(e, 255), t = h(t, 255);
  var n = Math.max(a, e, t),
    f = Math.min(a, e, t),
    r,
    o,
    l = (n + f) / 2;
  if (n == f) r = o = 0;else {
    var c = n - f;
    switch (o = l > 0.5 ? c / (2 - n - f) : c / (n + f), n) {
      case a:
        r = (e - t) / c + (e < t ? 6 : 0);
        break;
      case e:
        r = (t - a) / c + 2;
        break;
      case t:
        r = (a - e) / c + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: o,
    l
  };
}
function O(a, e, t) {
  var n, f, r;
  a = h(a, 360), e = h(e, 100), t = h(t, 100);
  function o(u, v, s) {
    return s < 0 && (s += 1), s > 1 && (s -= 1), s < 1 / 6 ? u + (v - u) * 6 * s : s < 1 / 2 ? v : s < 2 / 3 ? u + (v - u) * (2 / 3 - s) * 6 : u;
  }
  if (e === 0) n = f = r = t;else {
    var l = t < 0.5 ? t * (1 + e) : t + e - t * e,
      c = 2 * t - l;
    n = o(c, l, a + 1 / 3), f = o(c, l, a), r = o(c, l, a - 1 / 3);
  }
  return {
    r: n * 255,
    g: f * 255,
    b: r * 255
  };
}
function T(a, e, t) {
  a = h(a, 255), e = h(e, 255), t = h(t, 255);
  var n = Math.max(a, e, t),
    f = Math.min(a, e, t),
    r,
    o,
    l = n,
    c = n - f;
  if (o = n === 0 ? 0 : c / n, n == f) r = 0;else {
    switch (n) {
      case a:
        r = (e - t) / c + (e < t ? 6 : 0);
        break;
      case e:
        r = (t - a) / c + 2;
        break;
      case t:
        r = (a - e) / c + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: o,
    v: l
  };
}
function G(a, e, t) {
  a = h(a, 360) * 6, e = h(e, 100), t = h(t, 100);
  var n = Math.floor(a),
    f = a - n,
    r = t * (1 - e),
    o = t * (1 - f * e),
    l = t * (1 - (1 - f) * e),
    c = n % 6,
    u = [t, o, r, r, l, t][c],
    v = [l, t, t, o, r, r][c],
    s = [r, r, l, t, t, o][c];
  return {
    r: u * 255,
    g: v * 255,
    b: s * 255
  };
}
function M(a, e, t, n) {
  var f = [L(Math.round(a).toString(16)), L(Math.round(e).toString(16)), L(Math.round(t).toString(16))];
  return n && f[0].charAt(0) == f[0].charAt(1) && f[1].charAt(0) == f[1].charAt(1) && f[2].charAt(0) == f[2].charAt(1) ? f[0].charAt(0) + f[1].charAt(0) + f[2].charAt(0) : f.join("");
}
function j(a, e, t, n, f) {
  var r = [L(Math.round(a).toString(16)), L(Math.round(e).toString(16)), L(Math.round(t).toString(16)), L(C(n))];
  return f && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) && r[3].charAt(0) == r[3].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) + r[3].charAt(0) : r.join("");
}
function H(a, e, t, n) {
  var f = [L(C(n)), L(Math.round(a).toString(16)), L(Math.round(e).toString(16)), L(Math.round(t).toString(16))];
  return f.join("");
}
i.equals = function (a, e) {
  return !a || !e ? !1 : i(a).toRgbString() == i(e).toRgbString();
};
i.random = function () {
  return i.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function V(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = i(a).toHsl();
  return t.s -= e / 100, t.s = S(t.s), i(t);
}
function B(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = i(a).toHsl();
  return t.s += e / 100, t.s = S(t.s), i(t);
}
function D(a) {
  return i(a).desaturate(100);
}
function q(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = i(a).toHsl();
  return t.l += e / 100, t.l = S(t.l), i(t);
}
function U(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = i(a).toRgb();
  return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(e / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(e / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(e / 100)))), i(t);
}
function Z(a, e) {
  e = e === 0 ? 0 : e || 10;
  var t = i(a).toHsl();
  return t.l -= e / 100, t.l = S(t.l), i(t);
}
function J(a, e) {
  var t = i(a).toHsl(),
    n = (t.h + e) % 360;
  return t.h = n < 0 ? 360 + n : n, i(t);
}
function K(a) {
  var e = i(a).toHsl();
  return e.h = (e.h + 180) % 360, i(e);
}
function A(a, e) {
  if (isNaN(e) || e <= 0) throw new Error("Argument to polyad must be a positive number");
  for (var t = i(a).toHsl(), n = [i(a)], f = 360 / e, r = 1; r < e; r++) n.push(i({
    h: (t.h + r * f) % 360,
    s: t.s,
    l: t.l
  }));
  return n;
}
function Q(a) {
  var e = i(a).toHsl(),
    t = e.h;
  return [i(a), i({
    h: (t + 72) % 360,
    s: e.s,
    l: e.l
  }), i({
    h: (t + 216) % 360,
    s: e.s,
    l: e.l
  })];
}
function Y(a, e, t) {
  e = e || 6, t = t || 30;
  var n = i(a).toHsl(),
    f = 360 / t,
    r = [i(a)];
  for (n.h = (n.h - (f * e >> 1) + 720) % 360; --e;) n.h = (n.h + f) % 360, r.push(i(n));
  return r;
}
function ee(a, e) {
  e = e || 6;
  for (var t = i(a).toHsv(), n = t.h, f = t.s, r = t.v, o = [], l = 1 / e; e--;) o.push(i({
    h: n,
    s: f,
    v: r
  })), r = (r + l) % 1;
  return o;
}
i.mix = function (a, e, t) {
  t = t === 0 ? 0 : t || 50;
  var n = i(a).toRgb(),
    f = i(e).toRgb(),
    r = t / 100,
    o = {
      r: (f.r - n.r) * r + n.r,
      g: (f.g - n.g) * r + n.g,
      b: (f.b - n.b) * r + n.b,
      a: (f.a - n.a) * r + n.a
    };
  return i(o);
};
i.readability = function (a, e) {
  var t = i(a),
    n = i(e);
  return (Math.max(t.getLuminance(), n.getLuminance()) + 0.05) / (Math.min(t.getLuminance(), n.getLuminance()) + 0.05);
};
i.isReadable = function (a, e, t) {
  var n = i.readability(a, e),
    f,
    r;
  switch (r = !1, f = ie(t), f.level + f.size) {
    case "AAsmall":
    case "AAAlarge":
      r = n >= 4.5;
      break;
    case "AAlarge":
      r = n >= 3;
      break;
    case "AAAsmall":
      r = n >= 7;
      break;
  }
  return r;
};
i.mostReadable = function (a, e, t) {
  var n = null,
    f = 0,
    r,
    o,
    l,
    c;
  t = t || {}, o = t.includeFallbackColors, l = t.level, c = t.size;
  for (var u = 0; u < e.length; u++) r = i.readability(a, e[u]), r > f && (f = r, n = i(e[u]));
  return i.isReadable(a, n, {
    level: l,
    size: c
  }) || !o ? n : (t.includeFallbackColors = !1, i.mostReadable(a, ["#fff", "#000"], t));
};
var k = i.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  },
  te = i.hexNames = ae(k);
function ae(a) {
  var e = {};
  for (var t in a) a.hasOwnProperty(t) && (e[a[t]] = t);
  return e;
}
function w(a) {
  return a = parseFloat(a), (isNaN(a) || a < 0 || a > 1) && (a = 1), a;
}
function h(a, e) {
  ne(a) && (a = "100%");
  var t = fe(a);
  return a = Math.min(e, Math.max(0, parseFloat(a))), t && (a = parseInt(a * e, 10) / 100), Math.abs(a - e) < 1e-6 ? 1 : a % e / parseFloat(e);
}
function S(a) {
  return Math.min(1, Math.max(0, a));
}
function d(a) {
  return parseInt(a, 16);
}
function ne(a) {
  return typeof a == "string" && a.indexOf(".") != -1 && parseFloat(a) === 1;
}
function fe(a) {
  return typeof a == "string" && a.indexOf("%") != -1;
}
function L(a) {
  return a.length == 1 ? "0" + a : "" + a;
}
function I(a) {
  return a <= 1 && (a = a * 100 + "%"), a;
}
function C(a) {
  return Math.round(parseFloat(a) * 255).toString(16);
}
function E(a) {
  return d(a) / 255;
}
var m = function () {
  var a = "[-\\+]?\\d+%?",
    e = "[-\\+]?\\d*\\.\\d+%?",
    t = "(?:" + e + ")|(?:" + a + ")",
    n = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?",
    f = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(t),
    rgb: new RegExp("rgb" + n),
    rgba: new RegExp("rgba" + f),
    hsl: new RegExp("hsl" + n),
    hsla: new RegExp("hsla" + f),
    hsv: new RegExp("hsv" + n),
    hsva: new RegExp("hsva" + f),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function g(a) {
  return !!m.CSS_UNIT.exec(a);
}
function re(a) {
  a = a.replace(W, "").replace(X, "").toLowerCase();
  var e = !1;
  if (k[a]) a = k[a], e = !0;else if (a == "transparent") return {
    r: 0,
    g: 0,
    b: 0,
    a: 0,
    format: "name"
  };
  var t;
  return (t = m.rgb.exec(a)) ? {
    r: t[1],
    g: t[2],
    b: t[3]
  } : (t = m.rgba.exec(a)) ? {
    r: t[1],
    g: t[2],
    b: t[3],
    a: t[4]
  } : (t = m.hsl.exec(a)) ? {
    h: t[1],
    s: t[2],
    l: t[3]
  } : (t = m.hsla.exec(a)) ? {
    h: t[1],
    s: t[2],
    l: t[3],
    a: t[4]
  } : (t = m.hsv.exec(a)) ? {
    h: t[1],
    s: t[2],
    v: t[3]
  } : (t = m.hsva.exec(a)) ? {
    h: t[1],
    s: t[2],
    v: t[3],
    a: t[4]
  } : (t = m.hex8.exec(a)) ? {
    r: d(t[1]),
    g: d(t[2]),
    b: d(t[3]),
    a: E(t[4]),
    format: e ? "name" : "hex8"
  } : (t = m.hex6.exec(a)) ? {
    r: d(t[1]),
    g: d(t[2]),
    b: d(t[3]),
    format: e ? "name" : "hex"
  } : (t = m.hex4.exec(a)) ? {
    r: d(t[1] + "" + t[1]),
    g: d(t[2] + "" + t[2]),
    b: d(t[3] + "" + t[3]),
    a: E(t[4] + "" + t[4]),
    format: e ? "name" : "hex8"
  } : (t = m.hex3.exec(a)) ? {
    r: d(t[1] + "" + t[1]),
    g: d(t[2] + "" + t[2]),
    b: d(t[3] + "" + t[3]),
    format: e ? "name" : "hex"
  } : !1;
}
function ie(a) {
  var e, t;
  return a = a || {
    level: "AA",
    size: "small"
  }, e = (a.level || "AA").toUpperCase(), t = (a.size || "small").toLowerCase(), e !== "AA" && e !== "AAA" && (e = "AA"), t !== "small" && t !== "large" && (t = "small"), {
    level: e,
    size: t
  };
}
const oe = [{
  name: "action/surface/success/hover",
  type: "FILL",
  value: "#c1d7b3ff"
}, {
  name: "interface/stroke/informative",
  type: "FILL",
  value: "#ebe5fbff"
}, {
  name: "interface/stroke/success",
  type: "FILL",
  value: "#e1ecdaff"
}, {
  name: "interface/stroke/informative/inverse",
  type: "FILL",
  value: "#6c50bfff"
}, {
  name: "interface/stroke/success/inverse",
  type: "FILL",
  value: "#377114ff"
}, {
  name: "interface/content/data07",
  type: "FILL",
  value: "#5c75b4ff"
}, {
  name: "action/stroke/informative/idle",
  type: "FILL",
  value: "#d5caf6ff"
}, {
  name: "action/stroke/success/idle",
  type: "FILL",
  value: "#c1d7b3ff"
}, {
  name: "action/surface/success/active",
  type: "FILL",
  value: "#a1c38cff"
}, {
  name: "action/surface/success/inverse/idle",
  type: "FILL",
  value: "#428718ff"
}, {
  name: "interface/surface/data04",
  type: "FILL",
  value: "#f8edf5ff"
}, {
  name: "interface/surface/data05",
  type: "FILL",
  value: "#ebf1fcff"
}, {
  name: "interface/surface/data08",
  type: "FILL",
  value: "#f1f2ebff"
}, {
  name: "interface/content/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/surface/success/inverse",
  type: "FILL",
  value: "#428718ff"
}, {
  name: "interface/surface/informative",
  type: "FILL",
  value: "#f2effcff"
}, {
  name: "interface/surface/success",
  type: "FILL",
  value: "#ecf3e8ff"
}, {
  name: "interface/surface/informative/inverse",
  type: "FILL",
  value: "#815fe3ff"
}, {
  name: "interface/surface/warning",
  type: "FILL",
  value: "#faede6ff"
}, {
  name: "interface/content/warning",
  type: "FILL",
  value: "#cd4d05ff"
}, {
  name: "interface/surface/data01",
  type: "FILL",
  value: "#eaf2f4ff"
}, {
  name: "action/surface/informative/inverse/hover",
  type: "FILL",
  value: "#6c50bfff"
}, {
  name: "action/surface/informative/inverse/active",
  type: "FILL",
  value: "#58419aff"
}, {
  name: "action/stroke/warning/hover",
  type: "FILL",
  value: "#e6a682ff"
}, {
  name: "interface/stroke/warning",
  type: "FILL",
  value: "#f7e3d7ff"
}, {
  name: "interface/stroke/warning/inverse",
  type: "FILL",
  value: "#ac4104ff"
}, {
  name: "interface/content/data03",
  type: "FILL",
  value: "#af6323ff"
}, {
  name: "interface/content/data04",
  type: "FILL",
  value: "#bd4b96ff"
}, {
  name: "action/surface/informative/inverse/idle",
  type: "FILL",
  value: "#815fe3ff"
}, {
  name: "action/surface/informative/active",
  type: "FILL",
  value: "#c0aff1ff"
}, {
  name: "action/surface/success/inverse/active",
  type: "FILL",
  value: "#2d5c10ff"
}, {
  name: "interface/content/success",
  type: "FILL",
  value: "#428718ff"
}, {
  name: "interface/content/data08",
  type: "FILL",
  value: "#6f7b3bff"
}, {
  name: "action/surface/informative/idle",
  type: "FILL",
  value: "#ebe5fbff"
}, {
  name: "interface/surface/data02",
  type: "FILL",
  value: "#f1effdff"
}, {
  name: "interface/content/informative",
  type: "FILL",
  value: "#815fe3ff"
}, {
  name: "action/surface/informative/hover",
  type: "FILL",
  value: "#d5caf6ff"
}, {
  name: "interface/content/data05",
  type: "FILL",
  value: "#3970e2ff"
}, {
  name: "action/surface/success/idle",
  type: "FILL",
  value: "#e1ecdaff"
}, {
  name: "action/surface/success/inverse/hover",
  type: "FILL",
  value: "#377114ff"
}, {
  name: "interface/content/data06",
  type: "FILL",
  value: "#af5978ff"
}, {
  name: "interface/surface/data03",
  type: "FILL",
  value: "#f7efe9ff"
}, {
  name: "interface/surface/data06",
  type: "FILL",
  value: "#f7eef2ff"
}, {
  name: "interface/surface/data07",
  type: "FILL",
  value: "#eff1f8ff"
}, {
  name: "interface/content/data01",
  type: "FILL",
  value: "#2d7f90ff"
}, {
  name: "interface/content/data02",
  type: "FILL",
  value: "#7360eeff"
}, {
  name: "action/content/informative/idle",
  type: "FILL",
  value: "#6c50bfff"
}, {
  name: "action/content/success/active",
  type: "FILL",
  value: "#21440cff"
}, {
  name: "action/content/informative/active",
  type: "FILL",
  value: "#413072ff"
}, {
  name: "action/content/success/idle",
  type: "FILL",
  value: "#377114ff"
}, {
  name: "action/content/success/hover",
  type: "FILL",
  value: "#2d5c10ff"
}, {
  name: "action/content/informative/hover",
  type: "FILL",
  value: "#58419aff"
}, {
  name: "action/stroke/success/hover",
  type: "FILL",
  value: "#a1c38cff"
}, {
  name: "action/stroke/informative/hover",
  type: "FILL",
  value: "#c0aff1ff"
}, {
  name: "action/stroke/success/active",
  type: "FILL",
  value: "#6da24eff"
}, {
  name: "action/stroke/informative/active",
  type: "FILL",
  value: "#9c81e9ff"
}, {
  name: "action/content/warning/active",
  type: "FILL",
  value: "#672703ff"
}, {
  name: "action/surface/warning/idle",
  type: "FILL",
  value: "#f7e3d7ff"
}, {
  name: "action/surface/warning/active",
  type: "FILL",
  value: "#e6a682ff"
}, {
  name: "action/content/warning/hover",
  type: "FILL",
  value: "#8b3403ff"
}, {
  name: "action/surface/warning/inverse/idle",
  type: "FILL",
  value: "#cd4d05ff"
}, {
  name: "action/surface/warning/inverse/hover",
  type: "FILL",
  value: "#ac4104ff"
}, {
  name: "action/surface/warning/hover",
  type: "FILL",
  value: "#efc4adff"
}, {
  name: "action/stroke/warning/idle",
  type: "FILL",
  value: "#efc4adff"
}, {
  name: "action/content/warning/idle",
  type: "FILL",
  value: "#ac4104ff"
}, {
  name: "action/surface/warning/inverse/active",
  type: "FILL",
  value: "#8b3403ff"
}, {
  name: "action/stroke/warning/active",
  type: "FILL",
  value: "#d97841ff"
}, {
  name: "interface/surface/warning/inverse",
  type: "FILL",
  value: "#cd4d05ff"
}, {
  name: "action/content/neutral/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/content/warning/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/content/success/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/content/accent/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/content/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/content/informative/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "input/outline/success",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#e1ecdaff"
  }]
}, {
  name: "interface/content/informative/bold",
  type: "FILL",
  value: "#58419aff"
}, {
  name: "interface/content/warning/bold",
  type: "FILL",
  value: "#8b3403ff"
}, {
  name: "input/stroke/success",
  type: "FILL",
  value: "#428718ff"
}, {
  name: "interface/content/success/bold",
  type: "FILL",
  value: "#2d5c10ff"
}, {
  name: "input/stroke/informative",
  type: "FILL",
  value: "#815fe3ff"
}, {
  name: "interface/content/success/bolder",
  type: "FILL",
  value: "#162e08ff"
}, {
  name: "input/surface",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "input/stroke/warning",
  type: "FILL",
  value: "#cd4d05ff"
}, {
  name: "input/outline/warning",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#f7e3d7ff"
  }]
}, {
  name: "input/stroke/error",
  type: "FILL",
  value: "#dc3a24ff"
}, {
  name: "interface/content/informative/bolder",
  type: "FILL",
  value: "#2c204dff"
}, {
  name: "interface/content/warning/bolder",
  type: "FILL",
  value: "#461a02ff"
}, {
  name: "body/m/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 14,
    lineHeightPx: 23,
    letterSpacing: 0
  }
}, {
  name: "body/m/light",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    lineHeightPx: 21,
    letterSpacing: 0
  }
}, {
  name: "body/m",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 14,
    lineHeightPx: 23,
    letterSpacing: 0
  }
}, {
  name: "body/s",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 12,
    lineHeightPx: 20,
    letterSpacing: 0
  }
}, {
  name: "action/outline/focus",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#815fe352"
  }]
}, {
  name: "detail/xxl/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 16,
    lineHeightPx: 18,
    letterSpacing: 0
  }
}, {
  name: "body/xxl/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 20,
    lineHeightPx: 29,
    letterSpacing: 0
  }
}, {
  name: "title/l",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 24,
    lineHeightPx: 33,
    letterSpacing: -0.24
  }
}, {
  name: "title/s",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 18,
    lineHeightPx: 24,
    letterSpacing: 0
  }
}, {
  name: "title/xs",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 16,
    lineHeightPx: 22,
    letterSpacing: -0.08
  }
}, {
  name: "body/xxl",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 20,
    lineHeightPx: 29,
    letterSpacing: 0
  }
}, {
  name: "detail/l/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 12,
    lineHeightPx: 14,
    letterSpacing: 0
  }
}, {
  name: "detail/xxl/light",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 16,
    lineHeightPx: 18,
    letterSpacing: 0
  }
}, {
  name: "title/xxl",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 36,
    lineHeightPx: 46,
    letterSpacing: -0.54
  }
}, {
  name: "interface/surface",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "body/l/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 16,
    lineHeightPx: 25,
    letterSpacing: -0.08
  }
}, {
  name: "body/l",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 16,
    lineHeightPx: 25,
    letterSpacing: 0
  }
}, {
  name: "body/xl/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 18,
    lineHeightPx: 27,
    letterSpacing: 0
  }
}, {
  name: "title/xl",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 28,
    lineHeightPx: 37,
    letterSpacing: -0.28
  }
}, {
  name: "body/s/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 12,
    lineHeightPx: 20,
    letterSpacing: 0
  }
}, {
  name: "detail/l/light",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 12,
    lineHeightPx: 14,
    letterSpacing: 0
  }
}, {
  name: "body/l/light",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 16,
    lineHeightPx: 23,
    letterSpacing: 0
  }
}, {
  name: "body/xl",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 18,
    lineHeightPx: 27,
    letterSpacing: 0
  }
}, {
  name: "body/xl/light",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 18,
    lineHeightPx: 25,
    letterSpacing: 0
  }
}, {
  name: "title/m",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 20,
    lineHeightPx: 27,
    letterSpacing: 0
  }
}, {
  name: "detail/xl/light",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    lineHeightPx: 16,
    letterSpacing: 0
  }
}, {
  name: "detail/l",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 12,
    lineHeightPx: 14,
    letterSpacing: 0
  }
}, {
  name: "action/surface",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/stroke/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/stroke/data07",
  type: "FILL",
  value: "#e5e9f3ff"
}, {
  name: "interface/stroke/data04",
  type: "FILL",
  value: "#f4e2eeff"
}, {
  name: "interface/stroke/data03",
  type: "FILL",
  value: "#f2e6dcff"
}, {
  name: "interface/stroke/data05",
  type: "FILL",
  value: "#dfe8faff"
}, {
  name: "interface/stroke/data08",
  type: "FILL",
  value: "#e8eae0ff"
}, {
  name: "interface/stroke/data02",
  type: "FILL",
  value: "#e9e6fcff"
}, {
  name: "interface/stroke/data01",
  type: "FILL",
  value: "#ddebedff"
}, {
  name: "interface/stroke/data06",
  type: "FILL",
  value: "#f2e4e9ff"
}, {
  name: "action/surface/error/inverse/hover",
  type: "FILL",
  value: "#b9311eff"
}, {
  name: "action/surface/error/hover",
  type: "FILL",
  value: "#f3beb7ff"
}, {
  name: "interface/content/error",
  type: "FILL",
  value: "#dc3a24ff"
}, {
  name: "action/stroke/error/hover",
  type: "FILL",
  value: "#ee9d92ff"
}, {
  name: "interface/surface/error",
  type: "FILL",
  value: "#fcebe9ff"
}, {
  name: "interface/stroke/error",
  type: "FILL",
  value: "#f9dfdcff"
}, {
  name: "action/content/error/idle",
  type: "FILL",
  value: "#b9311eff"
}, {
  name: "interface/surface/error/inverse",
  type: "FILL",
  value: "#dc3a24ff"
}, {
  name: "interface/stroke/error/inverse",
  type: "FILL",
  value: "#b9311eff"
}, {
  name: "input/outline/error",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#f9dfdcff"
  }]
}, {
  name: "interface/content/error/bolder",
  type: "FILL",
  value: "#4b140cff"
}, {
  name: "interface/content/error/bold",
  type: "FILL",
  value: "#962718ff"
}, {
  name: "action/content/error/hover",
  type: "FILL",
  value: "#962718ff"
}, {
  name: "action/content/error/active",
  type: "FILL",
  value: "#6e1d12ff"
}, {
  name: "action/surface/error/inverse/active",
  type: "FILL",
  value: "#962718ff"
}, {
  name: "action/stroke/error/active",
  type: "FILL",
  value: "#e46959ff"
}, {
  name: "action/surface/error/idle",
  type: "FILL",
  value: "#f9dfdcff"
}, {
  name: "action/surface/error/active",
  type: "FILL",
  value: "#ee9d92ff"
}, {
  name: "action/content/error/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/stroke/error/idle",
  type: "FILL",
  value: "#f3beb7ff"
}, {
  name: "detail/xl/bold",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 800,
    fontSize: 14,
    lineHeightPx: 16,
    letterSpacing: 0
  }
}, {
  name: "link/s",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 14,
    lineHeightPx: 16,
    letterSpacing: 0
  }
}, {
  name: "link/s/hover",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 14,
    lineHeightPx: 16,
    letterSpacing: 0
  }
}, {
  name: "link/m",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 16,
    lineHeightPx: 18,
    letterSpacing: 0
  }
}, {
  name: "interface/link/active",
  type: "FILL",
  value: "#005487ff"
}, {
  name: "link/m/hover",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 16,
    lineHeightPx: 18,
    letterSpacing: 0
  }
}, {
  name: "interface/overlay/gradient-right",
  type: "FILL",
  value: {
    angle: 90,
    colors: [{
      color: "#ffffff00",
      position: 0
    }, {
      color: "#ffffffff",
      position: 1
    }]
  }
}, {
  name: "interface/overlay/gradient-top",
  type: "FILL",
  value: {
    angle: 0,
    colors: [{
      color: "#ffffff00",
      position: 0
    }, {
      color: "#ffffffff",
      position: 1
    }]
  }
}, {
  name: "interface/overlay/gradient-bottom",
  type: "FILL",
  value: {
    angle: 0,
    colors: [{
      color: "#ffffffff",
      position: 0
    }, {
      color: "#ffffff00",
      position: 1
    }]
  }
}, {
  name: "interface/overlay/gradient-left",
  type: "FILL",
  value: {
    angle: 90,
    colors: [{
      color: "#ffffffff",
      position: 0
    }, {
      color: "#ffffff00",
      position: 1
    }]
  }
}, {
  name: "interface/content/data08/bold",
  type: "FILL",
  value: "#4b5428ff"
}, {
  name: "interface/content/data08/bolder",
  type: "FILL",
  value: "#262a14ff"
}, {
  name: "interface/stroke/data08/inverse",
  type: "FILL",
  value: "#5d6732ff"
}, {
  name: "interface/content/data05/bold",
  type: "FILL",
  value: "#274c9aff"
}, {
  name: "interface/content/data03/bolder",
  type: "FILL",
  value: "#3c220cff"
}, {
  name: "interface/content/data03/bold",
  type: "FILL",
  value: "#774318ff"
}, {
  name: "interface/content/data04/bolder",
  type: "FILL",
  value: "#401a33ff"
}, {
  name: "interface/content/data04/bold",
  type: "FILL",
  value: "#813366ff"
}, {
  name: "interface/content/data05/bolder",
  type: "FILL",
  value: "#13264dff"
}, {
  name: "interface/surface/data01/inverse",
  type: "FILL",
  value: "#2d7f90ff"
}, {
  name: "interface/content/data07/bold",
  type: "FILL",
  value: "#3f507aff"
}, {
  name: "interface/content/data07/bolder",
  type: "FILL",
  value: "#1f283dff"
}, {
  name: "interface/stroke/data07/inverse",
  type: "FILL",
  value: "#4d6297ff"
}, {
  name: "interface/stroke/data05/inverse",
  type: "FILL",
  value: "#305ebeff"
}, {
  name: "interface/content/data06/bold",
  type: "FILL",
  value: "#773d52ff"
}, {
  name: "interface/content/data01/bold",
  type: "FILL",
  value: "#1f5662ff"
}, {
  name: "interface/content/data02/bolder",
  type: "FILL",
  value: "#272151ff"
}, {
  name: "interface/content/data01/bolder",
  type: "FILL",
  value: "#0f2b31ff"
}, {
  name: "interface/stroke/data04/inverse",
  type: "FILL",
  value: "#9f3f7eff"
}, {
  name: "interface/surface/data02/inverse",
  type: "FILL",
  value: "#7360eeff"
}, {
  name: "interface/surface/data03/inverse",
  type: "FILL",
  value: "#af6323ff"
}, {
  name: "interface/stroke/data03/inverse",
  type: "FILL",
  value: "#93531dff"
}, {
  name: "interface/stroke/data02/inverse",
  type: "FILL",
  value: "#6151c8ff"
}, {
  name: "interface/surface/data06/inverse",
  type: "FILL",
  value: "#af5978ff"
}, {
  name: "interface/stroke/data01/inverse",
  type: "FILL",
  value: "#266b79ff"
}, {
  name: "interface/surface/data07/inverse",
  type: "FILL",
  value: "#5c75b4ff"
}, {
  name: "interface/content/data06/bolder",
  type: "FILL",
  value: "#3c1e29ff"
}, {
  name: "interface/surface/data05/inverse",
  type: "FILL",
  value: "#3970e2ff"
}, {
  name: "interface/content/data02/bold",
  type: "FILL",
  value: "#4e41a2ff"
}, {
  name: "interface/surface/data08/inverse",
  type: "FILL",
  value: "#6f7b3bff"
}, {
  name: "interface/surface/data04/inverse",
  type: "FILL",
  value: "#bd4b96ff"
}, {
  name: "interface/stroke/data06/inverse",
  type: "FILL",
  value: "#934b65ff"
}, {
  name: "interface/overlay/gradient-top/bold",
  type: "FILL",
  value: {
    angle: 0,
    colors: [{
      color: "#ffffff00",
      position: 0
    }, {
      color: "#ffffffff",
      position: 0.3854166567325592
    }, {
      color: "#ffffffff",
      position: 1
    }]
  }
}, {
  name: "interface/overlay/gradient-left/bold",
  type: "FILL",
  value: {
    angle: 90,
    colors: [{
      color: "#ffffffff",
      position: 0
    }, {
      color: "#ffffffff",
      position: 0.5885416865348816
    }, {
      color: "#ffffff00",
      position: 1
    }]
  }
}, {
  name: "interface/overlay/gradient-right/bold",
  type: "FILL",
  value: {
    angle: 90,
    colors: [{
      color: "#ffffff00",
      position: 0
    }, {
      color: "#ffffffff",
      position: 0.3385416567325592
    }]
  }
}, {
  name: "interface/overlay/gradient-bottom/bold",
  type: "FILL",
  value: {
    angle: 0,
    colors: [{
      color: "#ffffffff",
      position: 0
    }, {
      color: "#ffffffff",
      position: 0.5833333134651184
    }, {
      color: "#ffffff00",
      position: 1
    }]
  }
}, {
  name: "detail/xl",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 14,
    lineHeightPx: 16,
    letterSpacing: 0
  }
}, {
  name: "detail/xxl",
  type: "TEXT",
  value: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 16,
    lineHeightPx: 18,
    letterSpacing: 0
  }
}, {
  name: "interface/overlay/inverse",
  type: "FILL",
  value: "#ffffffb8"
}, {
  name: "interface/content/accent/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/content/error/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/content/neutral/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/content/success/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/content/warning/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "interface/content/informative/inverse",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "primitive/black",
  type: "FILL",
  value: "#000000ff"
}, {
  name: "primitive/white",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "primitive/black/alpha",
  type: "FILL",
  value: "#0000000f"
}, {
  name: "primitive/white/alpha",
  type: "FILL",
  value: "#ffffff14"
}, {
  name: "primitive/neutral/0",
  type: "FILL",
  value: "#ffffffff"
}, {
  name: "action/surface/accent/inverse/hover",
  type: "FILL",
  value: "#003d52ff"
}, {
  name: "interface/surface/bold",
  type: "FILL",
  value: "#fbfbfbff"
}, {
  name: "interface/surface/accent/inverse/bold",
  type: "FILL",
  value: "#003142ff"
}, {
  name: "action/surface/accent/inverse/active",
  type: "FILL",
  value: "#003142ff"
}, {
  name: "primitive/accent/300",
  type: "FILL",
  value: "#b6f1ebff"
}, {
  name: "primitive/neutral/1100",
  type: "FILL",
  value: "#292929ff"
}, {
  name: "primitive/neutral/400",
  type: "FILL",
  value: "#bfbfbfff"
}, {
  name: "primitive/neutral/500",
  type: "FILL",
  value: "#949494ff"
}, {
  name: "action/surface/accent/active",
  type: "FILL",
  value: "#5ec0c9ff"
}, {
  name: "interface/content/neutral/bold",
  type: "FILL",
  value: "#525252ff"
}, {
  name: "interface/shadow/xxl",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 25,
    radius: 50,
    spread: -16,
    color: "#1f1f1f3d"
  }]
}, {
  name: "interface/surface/accent/bolder",
  type: "FILL",
  value: "#b6f1ebff"
}, {
  name: "action/surface/error/inverse/idle",
  type: "FILL",
  value: "#dc3924ff"
}, {
  name: "primitive/accent/500",
  type: "FILL",
  value: "#1fa1adff"
}, {
  name: "primitive/neutral/800",
  type: "FILL",
  value: "#666666ff"
}, {
  name: "action/surface/neutral/active",
  type: "FILL",
  value: "#bfbfbfff"
}, {
  name: "primitive/neutral/1000",
  type: "FILL",
  value: "#383838ff"
}, {
  name: "action/stroke/neutral/idle",
  type: "FILL",
  value: "#d9d9d9ff"
}, {
  name: "primitive/neutral/900",
  type: "FILL",
  value: "#525252ff"
}, {
  name: "action/stroke/neutral/active",
  type: "FILL",
  value: "#949494ff"
}, {
  name: "interface/surface/accent/inverse",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "input/outline/hover",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#e6e6e6ff"
  }]
}, {
  name: "interface/content/accent/bolder",
  type: "FILL",
  value: "#001f2eff"
}, {
  name: "interface/surface/neutral/bolder",
  type: "FILL",
  value: "#d9d9d9ff"
}, {
  name: "action/surface/neutral/inverse/idle",
  type: "FILL",
  value: "#737373ff"
}, {
  name: "interface/shadow/m",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 2,
    radius: 4,
    spread: -2,
    color: "#1f1f1f14"
  }, {
    x: 0,
    y: 4,
    radius: 8,
    spread: -1,
    color: "#1f1f1f14"
  }]
}, {
  name: "action/surface/accent/inverse/idle",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "action/content/neutral/hover",
  type: "FILL",
  value: "#525252ff"
}, {
  name: "action/stroke/accent/idle",
  type: "FILL",
  value: "#b6f1ebff"
}, {
  name: "primitive/accent/800",
  type: "FILL",
  value: "#003d52ff"
}, {
  name: "primitive/accent/1200",
  type: "FILL",
  value: "#001824ff"
}, {
  name: "interface/overlay/neutral",
  type: "FILL",
  value: "#292929b8"
}, {
  name: "interface/surface/neutral/inverse/bolder",
  type: "FILL",
  value: "#292929ff"
}, {
  name: "action/surface/neutral/hover",
  type: "FILL",
  value: "#d9d9d9ff"
}, {
  name: "primitive/accent/100",
  type: "FILL",
  value: "#e2f9f7ff"
}, {
  name: "action/stroke/accent/hover",
  type: "FILL",
  value: "#5ec0c9ff"
}, {
  name: "input/stroke/active",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "primitive/accent/50",
  type: "FILL",
  value: "#f8fefdff"
}, {
  name: "interface/surface/neutral",
  type: "FILL",
  value: "#f1f1f1ff"
}, {
  name: "primitive/neutral/100",
  type: "FILL",
  value: "#f1f1f1ff"
}, {
  name: "primitive/neutral/600",
  type: "FILL",
  value: "#8c8c8cff"
}, {
  name: "interface/content/accent/bold",
  type: "FILL",
  value: "#003142ff"
}, {
  name: "input/surface/active",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "input/surface/bold",
  type: "FILL",
  value: "#fbfbfbff"
}, {
  name: "primitive/neutral/1200",
  type: "FILL",
  value: "#1f1f1fff"
}, {
  name: "primitive/neutral/200",
  type: "FILL",
  value: "#e6e6e6ff"
}, {
  name: "interface/shadow/xs",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 1,
    radius: 2,
    spread: 0,
    color: "#1f1f1f0a"
  }, {
    x: 0,
    y: 2,
    radius: 4,
    spread: 0,
    color: "#1f1f1f0a"
  }]
}, {
  name: "primitive/neutral/50",
  type: "FILL",
  value: "#fbfbfbff"
}, {
  name: "interface/surface/neutral/bold",
  type: "FILL",
  value: "#e6e6e6ff"
}, {
  name: "interface/shadow/l",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 4,
    radius: 6,
    spread: -4,
    color: "#1f1f1f1a"
  }, {
    x: 0,
    y: 10,
    radius: 15,
    spread: -3,
    color: "#1f1f1f1a"
  }]
}, {
  name: "interface/stroke/neutral",
  type: "FILL",
  value: "#e6e6e6ff"
}, {
  name: "interface/surface/neutral/inverse/bold",
  type: "FILL",
  value: "#525252ff"
}, {
  name: "primitive/accent/1100",
  type: "FILL",
  value: "#001f2eff"
}, {
  name: "interface/shadow/s",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 2,
    radius: 5,
    spread: -1,
    color: "#1f1f1f0f"
  }, {
    x: 0,
    y: 2,
    radius: 5,
    spread: 0,
    color: "#1f1f1f0f"
  }]
}, {
  name: "interface/content/accent",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "interface/content/neutral",
  type: "FILL",
  value: "#737373ff"
}, {
  name: "input/outline/focus",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#004c6652"
  }]
}, {
  name: "interface/surface/accent/inverse/bolder",
  type: "FILL",
  value: "#001f2eff"
}, {
  name: "primitive/accent/1300",
  type: "FILL",
  value: "#000e14ff"
}, {
  name: "action/surface/accent/hover",
  type: "FILL",
  value: "#b6f1ebff"
}, {
  name: "action/content/neutral/idle",
  type: "FILL",
  value: "#666666ff"
}, {
  name: "action/content/neutral/active",
  type: "FILL",
  value: "#383838ff"
}, {
  name: "primitive/accent/900",
  type: "FILL",
  value: "#003142ff"
}, {
  name: "action/stroke/accent/active",
  type: "FILL",
  value: "#1fa1adff"
}, {
  name: "action/surface/neutral/idle",
  type: "FILL",
  value: "#e6e6e6ff"
}, {
  name: "action/content/accent/idle",
  type: "FILL",
  value: "#003d52ff"
}, {
  name: "primitive/neutral/700",
  type: "FILL",
  value: "#737373ff"
}, {
  name: "action/content/accent/active",
  type: "FILL",
  value: "#002838ff"
}, {
  name: "action/surface/accent/idle",
  type: "FILL",
  value: "#ccf5f1ff"
}, {
  name: "action/surface/neutral/inverse/hover",
  type: "FILL",
  value: "#666666ff"
}, {
  name: "primitive/accent/200",
  type: "FILL",
  value: "#ccf5f1ff"
}, {
  name: "primitive/accent/600",
  type: "FILL",
  value: "#0f6b8aff"
}, {
  name: "interface/content/neutral/bolder",
  type: "FILL",
  value: "#292929ff"
}, {
  name: "input/surface/bolder",
  type: "FILL",
  value: "#949494ff"
}, {
  name: "primitive/accent/1000",
  type: "FILL",
  value: "#002838ff"
}, {
  name: "interface/surface/accent/bold",
  type: "FILL",
  value: "#ccf5f1ff"
}, {
  name: "interface/stroke/neutral/inverse",
  type: "FILL",
  value: "#666666ff"
}, {
  name: "primitive/accent/700",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "action/content/accent/hover",
  type: "FILL",
  value: "#003142ff"
}, {
  name: "primitive/accent/400",
  type: "FILL",
  value: "#5ec0c9ff"
}, {
  name: "primitive/neutral/1300",
  type: "FILL",
  value: "#141414ff"
}, {
  name: "interface/stroke/accent",
  type: "FILL",
  value: "#ccf5f1ff"
}, {
  name: "input/outline/active",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 0,
    radius: 0,
    spread: 3,
    color: "#ccf5f1ff"
  }]
}, {
  name: "input/stroke/neutral",
  type: "FILL",
  value: "#949494ff"
}, {
  name: "interface/surface/accent",
  type: "FILL",
  value: "#e2f9f7ff"
}, {
  name: "interface/surface/neutral/inverse",
  type: "FILL",
  value: "#737373ff"
}, {
  name: "primitive/neutral/300",
  type: "FILL",
  value: "#d9d9d9ff"
}, {
  name: "action/stroke/neutral/hover",
  type: "FILL",
  value: "#bfbfbfff"
}, {
  name: "interface/shadow/xl",
  type: "EFFECT",
  value: [{
    x: 0,
    y: 8,
    radius: 10,
    spread: -6,
    color: "#1f1f1f1a"
  }, {
    x: 0,
    y: 20,
    radius: 25,
    spread: -5,
    color: "#1f1f1f1a"
  }]
}, {
  name: "action/surface/neutral/inverse/active",
  type: "FILL",
  value: "#525252ff"
}, {
  name: "interface/link",
  type: "FILL",
  value: "#0f6b8aff"
}, {
  name: "action/surface/accent/inverse/bold/idle",
  type: "FILL",
  value: "#003142ff"
}, {
  name: "action/surface/accent/inverse/bolder/active",
  type: "FILL",
  value: "#000e14ff"
}, {
  name: "action/surface/accent/inverse/bolder/idle",
  type: "FILL",
  value: "#001f2eff"
}, {
  name: "action/surface/accent/inverse/bolder/hover",
  type: "FILL",
  value: "#001824ff"
}, {
  name: "action/surface/accent/inverse/bold/active",
  type: "FILL",
  value: "#001f2eff"
}, {
  name: "action/surface/accent/inverse/bold/hover",
  type: "FILL",
  value: "#002838ff"
}, {
  name: "action/surface/accent/bold/active",
  type: "FILL",
  value: "#0f6b8aff"
}, {
  name: "action/surface/accent/bold/hover",
  type: "FILL",
  value: "#1fa1adff"
}, {
  name: "action/surface/accent/bold/idle",
  type: "FILL",
  value: "#5ec0c9ff"
}, {
  name: "interface/stroke/accent/inverse",
  type: "FILL",
  value: "#004c66ff"
}, {
  name: "action/content/accent",
  type: "FILL",
  value: "#ffffffff"
}];
class ce {
  constructor(e, t) {
    this.accentPalette = b.accentPalette, this.neutralPalette = b.neutralPalette, this.shadeLevels = b.shadeLevels, this.baseShadeLevel = b.baseShadeLevel, this.minShadeLevel = b.minShadeLevel, this.maxShadeLevel = b.maxShadeLevel, t && (this.baseFont = t), e && (this.baseColor = i(e).toHex8String(), this.generatePalettes());
  }
  generatePalettes() {
    const e = {},
      t = {},
      n = i(this.baseColor).toHsl();
    let f, r, o;
    this.shadeLevels.forEach(l => {
      const c = P(n, {
        level: l,
        currentHue: f,
        currentSaturation: r,
        currentLightness: o
      });
      f = c.hue, r = c.saturation, o = c.lightness, e[l] = i({
        h: c.hue,
        s: c.saturation,
        l: c.lightness,
        a: c.alpha
      }).toHex8String(), t[l] = i({
        h: c.neutralHue,
        s: c.neutralSaturation,
        l: c.neutralLightness,
        a: c.neutralAlpha
      }).toHex8String();
    }), this.accentPalette = e, this.neutralPalette = t;
  }
  convertFigmaTokensToCSS() {
    const e = {};
    return oe.forEach(({
      name: t,
      type: n,
      value: f
    }) => {
      let r;
      if (n === "FILL") if (typeof f == "object" && "angle" in f && "colors" in f) {
        const {
            angle: o,
            colors: l
          } = f,
          c = l == null ? void 0 : l.map(({
            color: u,
            position: v
          }) => `${u} ${v * 100}%`);
        r = `linear-gradient(${o}deg, ${c == null ? void 0 : c.join(", ")})`;
      } else r = `${f}`;
      if (n === "EFFECT" && Array.isArray(f) && (r = f.map(({
        x: l,
        y: c,
        radius: u,
        spread: v,
        color: s
      }) => `${l}px ${c}px ${u}px ${v}px ${s}`).join(", ")), n === "TEXT" && typeof f == "object" && "fontFamily" in f) {
        const {
          fontWeight: o,
          fontSize: l,
          lineHeightPx: c,
          fontFamily: u
        } = f;
        if (o && l && c) {
          const v = Math.round(o),
            s = Math.round(l),
            p = Math.round(c);
          r = `${v} ${s}px/${p}px ${u}`;
        }
      }
      e[`--chr-${t.split("/").join("-")}`] = r ?? `${f}`;
    }), e;
  }
  getMatchingColor(e, t = 4.5) {
    return Object.values(e).find(f => F({
      foreground: f,
      contrast: t
    })) || e[this.maxShadeLevel];
  }
  getColorGradient(e, t = 1) {
    const n = this.getMatchingColor(e),
      f = Object.keys(e),
      r = f.findIndex(c => e[c] === n),
      o = e[f[r + t] || this.maxShadeLevel],
      l = e[f[r + t * 2] || this.maxShadeLevel];
    return {
      color: n,
      darkenColor: o,
      darkestColor: l
    };
  }
  getStrokeColor(e, t) {
    if (!F({
      foreground: e,
      contrast: 3
    })) return this.getMatchingColor(t, 3);
  }
  getOverlayColor(e, t) {
    const n = i(t).getAlpha();
    return i(e).setAlpha(n).toHex8String();
  }
  getActionContentAccentColor(e) {
    return F({
      foreground: e[1300],
      background: e[900]
    }) ? e[1300] : "#FFFFFF";
  }
  getContentInverseColors(e) {
    if (F({
      foreground: e[this.baseShadeLevel]
    })) return;
    const n = F({
        foreground: e[this.maxShadeLevel]
      }) ? e[this.maxShadeLevel] : "#000000",
      f = e[this.baseShadeLevel - 100],
      r = e[this.baseShadeLevel - 200];
    return {
      content: n,
      hover: f,
      active: r
    };
  }
  replaceTextTokenValue(e) {
    if (!this.baseFont) return;
    const t = e.split(" ");
    return e.replace(t[t.length - 1], this.baseFont);
  }
  /**
   * Replaces colors from provided value with colors from the generated palette.
   * It also assigns the appropriate alpha channel.
   */
  replaceEffectTokenValue(e) {
    const t = e.split(" ").filter(r => r.includes("#")),
      n = [b.accentPalette, b.neutralPalette];
    let f;
    return n.forEach((r, o) => {
      const l = o === 0 ? this.accentPalette : this.neutralPalette;
      for (const [c, u] of Object.entries(r)) t.forEach(v => {
        if (i(u).toHexString() !== i(v).toHexString()) return;
        const s = i(v).getAlpha(),
          p = i(l[c]).setAlpha(s).toHex8String();
        f = e.replace(v, p);
      });
    }), f;
  }
  generateTheme() {
    const e = ["outline", "shadow", "overlay"],
      t = ["body", "title", "link", "detail"],
      n = this.convertFigmaTokensToCSS();
    for (const [f, r] of Object.entries(n)) {
      const o = R(r),
        l = (o || f).includes("accent"),
        c = (o || f).includes("neutral"),
        u = l ? this.accentPalette : this.neutralPalette,
        v = f.includes("accent") ? "accent" : "neutral";
      if (l || c) {
        if (o) {
          const s = z(o);
          let p = u[s];
          if (f.includes(`action-content-${v}`) && !F({
            foreground: u[800],
            background: u[200]
          })) {
            if (s != 800) continue;
            const y = this.getColorGradient(u);
            y && (p = y.color, n[`--chr-action-content-${v}-hover`] = y.darkenColor, n[`--chr-action-content-${v}-active`] = y.darkestColor);
          }
          if (f.includes(`interface-content-${v}`) && !F({
            foreground: p
          })) {
            if (s != this.baseShadeLevel) continue;
            const y = this.getColorGradient(u, 2);
            y && (p = y.color, n[`--chr-interface-content-${v}-bold`] = y.darkenColor, n[`--chr-interface-content-${v}-bolder`] = y.darkestColor);
          }
          f.includes("input-stroke") && (p = this.getStrokeColor(p, u) || p), f.includes("overlay") && (p = this.getOverlayColor(p, r) || p), n[f] = p;
        }
      } else {
        if (f === "--chr-action-content-accent" && (n[f] = this.getActionContentAccentColor(u)), f.includes(`action-content-${v}-inverse`) || f.includes(`interface-content-${v}-inverse`)) {
          const s = this.getContentInverseColors(u);
          n[f] = (s == null ? void 0 : s.content) || r, f.includes(`action-content-${v}-inverse`) && s && (n[`--chr-action-surface-${v}-inverse-hover`] = s.hover, n[`--chr-action-surface-${v}-inverse-active`] = s.active);
        }
        e.some(s => f.includes(s)) && (n[f] = this.replaceEffectTokenValue(r) || r), t.some(s => f.includes(s)) && (n[f] = this.replaceTextTokenValue(r) || r);
      }
    }
    return {
      baseColor: this.baseColor,
      baseShadeLevel: this.baseShadeLevel,
      accentPalette: this.accentPalette,
      neutralPalette: this.neutralPalette,
      theme: n
    };
  }
}
const se = (a, e) => new ce(a, e).generateTheme(),
  F = ({
    foreground: a,
    background: e = "#FFFFFF",
    contrast: t = 4.5
  }) => i.readability(a, e) >= t;
export { ce as ChrThemeGenerator, F as contrastPredicate, se as themeGenerator, i as tinycolor };